<template>
  <CCanvasModal hideFooter show verticalAlignment="top" :z-index="zIndex" @update:show="emit('toggleSearch', $event)">
    <div class="gap-4 flex flex-col overflow-hidden">
      <CSearch
        ref="searchRef"
        autofocus
        :modelValue="search"
        :placeholder="t('canvasUI.CGlobalSearch.search')"
        showIcon
        size="large"
        @update:modelValue="updateSearch"
      />

      <CGlobalSearchResults
        :instanceName="instanceName"
        :isLoading="isLoading"
        :organizationName="organizationName"
        :results="results"
        :root-folder-id="rootFolderId"
        :search="search"
        :searchRef="searchRef"
        @open="emit('open', $event)"
        @open-folder="emit('openFolder', $event)"
        @toggle-modal="emit('toggleSearch', $event)"
      />

      <CGlobalSearchShortcuts v-if="!isMobile" />
    </div>
  </CCanvasModal>
</template>

<script lang="ts" setup>
import type { Ref } from 'vue'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

import CCanvasModal from '@lib/components/CCanvasModal/CCanvasModal.vue'
import CSearch from '@lib/components/CSearch/CSearch.vue'
import CGlobalSearchShortcuts from '@lib/components/CGlobalSearch/CGlobalSearchShortcuts.vue'
import CGlobalSearchResults from '@lib/components/CGlobalSearch/CGlobalSearchResults.vue'
import type { GlobalSearchResult } from '@lib/components/CGlobalSearch/CGlobalSearch.types'
import type { Folder } from '@openapi'

interface Props {
  rootFolderId?: string
  isMobile: boolean
  isLoading: boolean
  results?: GlobalSearchResult[]
  organizationName: string
  instanceName: string
  zIndex?: number
}

defineProps<Props>()

const emit = defineEmits<{
  toggleSearch: [value: boolean]
  'update:search': [value: string]
  open: [value: GlobalSearchResult]
  openFolder: [folderId: Folder['id']]
}>()

const searchRef: Ref<HTMLElement | null> = ref(null)
const search = ref('')
const { t } = useI18n()

const updateSearch = (newValue: string | null) => {
  const parsedValue = newValue ?? ''
  const trimmedValue = parsedValue.trim()
  emit('update:search', trimmedValue)
  search.value = parsedValue
}
</script>
